import { FileText, Plus } from '@gravity-ui/icons'
import { Button } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Card, CardContent } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import type { Report } from '@/types/report.types'

import { RecentReportItem } from './RecentReportItem'

interface RecentReportsProps {
  reports: Report[];
}

export function RecentReports({ reports }: RecentReportsProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Card className={'p-0'}>
      <CardContent>
        <div
          className="px-5 py-4 flex items-center justify-between border-b border-grey-100 dark:border-grey-800"
        >
          <h2 className="font-bold text-md">
            {t('dashboard.recent_reports')}
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/reports')}
          >
            {t('dashboard.all_reports')}
          </Button>
        </div>
        <div className="divide-y divide-zinc-100 dark:divide-zinc-800">
          {reports.length === 0 ? (
            <EmptyState
              icon={<FileText width={24} height={24} className="text-zinc-400" />}
              title={t('dashboard.empty_reports_title')}
              description={t('dashboard.empty_reports_subtitle')}
            >
              <Button
                variant="primary"
                size="lg"
                onClick={() => navigate('/reports/new')}
              >
                <Plus />
                {t('dashboard.create_first_report')}
              </Button>
            </EmptyState>
          ) : (
            reports.map(r => (
              <RecentReportItem
                key={r.id}
                report={r}
              />
            ))
          )}
        </div>
      </CardContent>
    </Card>
  )
}
